import React from 'react';
import PropTypes from 'prop-types';
import {
    Route
} from "react-router-dom";
import UiUtils from '../../utils/UiUtils';
import SearchBar from '../../components/search-bar/SearchBar';
import PersonasBusqueda from "./components/personas-busqueda/PersonasBusqueda";
import PersonasDetalle from "./components/personas-detalle/PersonasDetalle";
import {
    PERSONAS_SEARCH_OPTIONS
} from '../../config';

class Personas extends React.Component {

	onBusquedaHandler = (tipo, valor, nombre, provincia, nacionalidad, edadgt, edadlt) => {
		UiUtils.navigateTo(`/dashboard/personas/busqueda/${tipo}/${valor}|${nombre}|${provincia}|${nacionalidad}|${edadgt}|${edadlt}`);
	}

	onResultadoSeleccionado = (valor, isPerson) => {
		UiUtils.navigateTo(`/dashboard/${isPerson ? 'personas' : 'empresas'}/detalle/${valor}`);
	}

    render() {
        return (
            <div>
                <SearchBar
                    opciones={PERSONAS_SEARCH_OPTIONS}
                    onBusqueda={this.onBusquedaHandler}/>
                <Route
                    path={`${this.props.match.url}/busqueda/:tipo/:valor`}
                    render={({match}) => {
                    let pipedParams = match
                        .params
                        .valor
                        .split('|');
                    return (<PersonasBusqueda
                        tipo={match.params.tipo}
                        valor={pipedParams[0]}
                        nombre={pipedParams[1]}
                        provincia={pipedParams[2]}
                        nacionalidad={pipedParams[3]}
                        edadgt={pipedParams[4]}
                        edadlt={pipedParams[5]}
                        onResultadoSeleccionado={this.onResultadoSeleccionado}/>)
                }}/>
                <Route
                    path={`${this.props.match.url}/detalle/:cuil`}
                    render={({match}) => (<PersonasDetalle cuil={match.params.cuil}/>)}/>
            </div>
        );
    }
}

Personas.propTypes = {
	match: PropTypes.object
}

export default Personas;



// WEBPACK FOOTER //
// ./src/scenes/personas/Personas.js